import { createContext } from "react";

const ProductosCompraExternaContext = createContext();

export default ProductosCompraExternaContext;
